import React from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import useAuth from '../../auth/feature/auth';
import { adminService } from '../service/admin.service';
import {
  ErrorsChart,
  ResponseTimeChart,
  RevenueChart,
  RpmChart
} from '../../common/components/charts';

export const MetricsSection = () => {
  const { isAdmin } = useAuth();
  const queryClient = useQueryClient();

  if (!isAdmin) return null;

  const revenueMetricQuery = useQuery({
    queryKey: ['revenue-metric'],
    queryFn: () => adminService.getRevenueMetricData(),
    enabled: isAdmin,
    refetchInterval: 60 * 60 * 1000,
    retry: 3,
    retryDelay: 1000,
    staleTime: 90 * 60 * 1000,
    gcTime: 180 * 60 * 1000
  });

  const errorsMetricQuery = useQuery({
    queryKey: ['errors-metric'],
    queryFn: () => adminService.getErrorsMetricData(),
    enabled: isAdmin,
    refetchInterval: 60 * 60 * 1000,
    retry: 3,
    retryDelay: 1000,
    staleTime: 90 * 60 * 1000,
    gcTime: 180 * 60 * 1000
  });

  const rpmMetricQuery = useQuery({
    queryKey: ['rpm-metric'],
    queryFn: () => adminService.getRpmData(),
    enabled: isAdmin,
    refetchInterval: 60 * 60 * 1000,
    retry: 3,
    retryDelay: 1000,
    staleTime: 90 * 60 * 1000,
    gcTime: 180 * 60 * 1000
  });

  const responseTimeMetricQuery = useQuery({
    queryKey: ['response-time-metric'],
    queryFn: () => adminService.getResponseTimeData(),
    enabled: isAdmin,
    refetchInterval: 60 * 60 * 1000,
    retry: 3,
    retryDelay: 1000,
    staleTime: 90 * 60 * 1000,
    gcTime: 180 * 60 * 1000
  });

  return (
    <div className="w-full max-w-[1400px] mx-auto py-[40px] px-[20px]">
      <div className="grid grid-cols-1 tablet:grid-cols-2 gap-x-[16px] gap-y-[4px]">
        <RevenueChart
          data={revenueMetricQuery.data || []}
          isLoading={revenueMetricQuery.isLoading}
          isError={revenueMetricQuery.isError}
          onRefresh={() =>
            queryClient.invalidateQueries({ queryKey: ['revenue-metric'] })
          }
        />
        <ErrorsChart
          data={errorsMetricQuery.data || []}
          isLoading={errorsMetricQuery.isLoading}
          isError={errorsMetricQuery.isError}
          onRefresh={() =>
            queryClient.invalidateQueries({ queryKey: ['errors-metric'] })
          }
        />
        <RpmChart
          data={rpmMetricQuery.data || []}
          isLoading={rpmMetricQuery.isLoading}
          isError={rpmMetricQuery.isError}
          onRefresh={() =>
            queryClient.invalidateQueries({ queryKey: ['rpm-metric'] })
          }
        />
        <ResponseTimeChart
          data={responseTimeMetricQuery.data || {}}
          isLoading={responseTimeMetricQuery.isLoading}
          isError={responseTimeMetricQuery.isError}
          onRefresh={() =>
            queryClient.invalidateQueries({ queryKey: ['response-time-metric'] })
          }
        />
      </div>
    </div>
  );
};
